import React from 'react';

export interface Props {
  titulo?: string;
  children: React.ReactElement | React.ReactElement[] | string;
  exibir: boolean;
  aoFechar: (estado: boolean) => void;
  telaCheia?: boolean;
  telaCheiaMobile?: boolean;
  lg?: boolean;
}

const Modal = ({
  titulo,
  children,
  exibir,
  aoFechar,
  telaCheia = false,
  telaCheiaMobile = false,
  lg = false,
}: Props): React.ReactElement => {
  return (
    <React.Fragment>
      {exibir && (
        <React.Fragment>
          <div className="modal show animate__animated animate__fadeIn animate__faster d-block">
            <div
              className={[
                'modal-dialog modal-dialog-centered',
                telaCheia && 'modal-fullscreen',
                telaCheiaMobile && 'modal-fullscreen-md-down',
                lg && 'modal-lg',
              ].className()}
            >
              <div className="modal-content border-0">
                {titulo && (
                  <div className="modal-header">
                    <h5 className="modal-title">{titulo}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => aoFechar(false)}
                    />
                  </div>
                )}
                <div className="modal-body">{children}</div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={() => aoFechar(false)}
          ></div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Modal;
